import { z } from 'zod';
import { vocabularyCategorySchema } from './enums.js';
export const vocabularyTermSchema = z.object({
    id: z.string(),
    term: z.string(),
    category: vocabularyCategorySchema,
    aliases: z.array(z.string()),
});
export const createVocabularyInputSchema = z.object({
    term: z.string().min(1).max(200),
    category: vocabularyCategorySchema.default('OTHER'),
    aliases: z.array(z.string().min(1).max(200)).max(20).default([]),
});
export const updateVocabularyInputSchema = createVocabularyInputSchema.partial();
//# sourceMappingURL=vocabulary.js.map